import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

// Angular Material
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MaterialModule } from "../material-module/material.module";

// Nav
import { NavModule } from "../nav-module/nav.module";

// Notification
import { NotificationModalComponent } from "./notification-modal/notification-modal.component";
import { NotificationImportComponent } from "./notification-import/notification-import.component";

// Table
import { TableModule } from "../table-module/table.module";

// Translate
import { TranslateModule } from "@ngx-translate/core";

/** Module for the notification feature. */
@NgModule({
  imports: [
    CommonModule,
    // Angular Material
    MatButtonModule,
    MatIconModule,
    MaterialModule,
    // Nav
    NavModule,
    // Table
    TableModule,
    // Translate
    TranslateModule,
    NotificationModalComponent,
    NotificationImportComponent,
  ],
  exports: [NotificationModalComponent, NotificationImportComponent],
})
export class NotificationModule {}
